import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '@/views/Home'
import Latest from '@/views/ChapterLatest'
import NewPayment from '@/views/NewPayment'
import Login from '@/views/Login'
import firebase from 'firebase/app'

const Create = () => import(/* webpackChunkName: "create" */ '@/views/Create')
const Novels = () => import(/* webpackChunkName: "novels" */ '@/views/Novels')
const NovelDetail = () => import(/* webpackChunkName: "novelDetails" */ '@/views/NovelDetail')
const Donate = () => import(/* webpackChunkName: "donate" */ '@/views/Donate')
const Suggestion = () => import(/* webpackChunkName: "suggestion" */ '@/views/Suggestion')
const Readed = () => import(/* webpackChunkName: "readed" */ '@/views/Readed')
const Chapter = () => import(/* webpackChunkName: "chapter" */ '@/views/Chapter')
const Payments = () => import(/* webpackChunkName: "payments" */ '@/views/Payments')

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  fallback: false,
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        { path: '', name: 'latest', component: Latest },
        { path: 'novels', name: 'novels', component: Novels, props: { isDescription: true } },
        { path: 'donate', name: 'donate', component: Donate },
        { path: 'suggestion', name: 'suggestion', component: Suggestion },
        { path: 'readed', name: 'readed', component: Readed }
      ],
      meta: {
        title: 'หน้าแรก',
        metaTags: [
          { property: 'og:description', content: 'READ-THAI นิยายแปลไทย นิยายแฟนตาซี นิิยายแปล' },
          { property: 'og:title', content: 'ตอนล่าสุด' },
          { property: 'og:image', content: 'https://www.img.in.th/images/823ea6f7cfc16c8937fb196b733cab27.png' },
          { property: 'fb:app_id', content: '158911918041534' }
        ]
      }
    },
    { path: '/login', name: 'login', component: Login },
    { path: '/create', name: 'create', component: Create, meta: { requiresAdmin: true } },
    { path: '/subscriptions',
      name: 'subscriptions',
      component: NewPayment,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments,
      meta: { requiresAuth: true }
    },
    {
      path: '/user',
      component: Home,
      children: [
        { path: 'subscriptions', component: Home },
        { path: 'payments', component: Home }
      ]
    },
    {
      name: 'chapter',
      path: '/novel/:novelId/chapter/:chapterId',
      component: Chapter,
      props: true,
      meta: {
        title: 'นิยายแปลไทย@READ-THAI.COM',
        metaTags: [
          { property: 'og:description', content: 'READ-THAI นิยายแปลไทย นิยายแฟนตาซี นิิยายแปล' },
          { property: 'og:title', content: 'นิยายแปลไทย@READ-THAI.COM' },
          { property: 'og:image', content: 'https://www.img.in.th/images/823ea6f7cfc16c8937fb196b733cab27.png' },
          { property: 'fb:app_id', content: '158911918041534' }
        ]
      }
    },
    {
      name: 'novel',
      path: '/novel/:novelId',
      component: NovelDetail,
      props: true
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const user = firebase.auth().currentUser
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  }

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const isAdmin = firebase.auth().currentUser.email === 'pongsakorn.onsri@gmail.com'
    if (!isAdmin) {
      next({
        path: '/'
      })
    }
  }

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router
